import { Toggle } from 'components/GlobalUI';
import { leadFormOptions } from 'components/GroupEditor/Setup/Config';
import RadioForm from 'components/GroupEditor/Setup/Config/RadioForm';
import { Checkbox } from 'components/Inputs/Checkbox';
import { cloneDeep, get, set } from 'lodash';
import { LeadFormConfig as LeadFormConfigType } from '@upstart/harmony/lib/legos/leadFormTypes';

import React from 'react';

import './LeadForm.scss';

enum LeadFormPropPath {
  piiFlow = 'piiFlow',
  preferredContactEnabled = 'preferredContact.enabled',
  zipCodeEnabled = 'zipCode.enabled',
  zipCodeMandatory = 'zipCode.mandatory',
}

const LeadFormConfig = ({
  leadForm,
  onChange,
}: {
  leadForm: LeadFormConfigType;
  onChange: (leadForm: LeadFormConfigType) => void;
}) => {
  const handleChange = ({
    name,
    value,
  }: {
    name: string;
    value: boolean | number;
  }) => {
    const newLeadForm = cloneDeep(leadForm);
    set(newLeadForm, name, value);
    onChange(newLeadForm);
  };

  return (
    <div className="LeadFormConfig">
      <RadioForm
        options={leadFormOptions.map((props) => ({
          ...props,
          name: LeadFormPropPath.piiFlow,
        }))}
        sectionHeader="Lead Form Config"
        subHeader="PII Workflow"
        description="Require PII at First or Second Step of Workflow"
        selectedValue={leadForm?.piiFlow ?? 1}
        onSelect={({ target: { value } }) =>
          handleChange({ name: LeadFormPropPath.piiFlow, value: Number(value) })
        }
      />

      <div>
        <span className="toggle-label">Enable Zip Code on PII form</span>
        <Toggle
          onToggle={(value) =>
            handleChange({ name: LeadFormPropPath.zipCodeEnabled, value })
          }
          value={!!get(leadForm, LeadFormPropPath.zipCodeEnabled)}
        />
      </div>
      {!!get(leadForm, LeadFormPropPath.zipCodeEnabled) && (
        <Checkbox
          onChange={(value) =>
            handleChange({
              name: LeadFormPropPath.zipCodeMandatory,
              value,
            })
          }
          checked={!!get(leadForm, LeadFormPropPath.zipCodeMandatory)}
          label="Make Zip Code mandatory"
          id={LeadFormPropPath.zipCodeMandatory}
        />
      )}
      <div>
        <span className="toggle-label">
          Enable Preferred Contact on PII form
        </span>
        <Toggle
          onToggle={(value) =>
            handleChange({
              name: LeadFormPropPath.preferredContactEnabled,
              value,
            })
          }
          value={!!get(leadForm, LeadFormPropPath.preferredContactEnabled)}
        />
      </div>
    </div>
  );
};
export default LeadFormConfig;
